/**
 * BolsaDeProfissionais.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EstadoProfissionalEnum = 1 | 2;

export const EstadoProfissionalEnum = {

    NUMBER_1: 1 as EstadoProfissionalEnum,

    NUMBER_2: 2 as EstadoProfissionalEnum
};

